import PropTypes from 'prop-types';
var AppStore = require('../../store/appStore');
var moduleAction = require('../../action/moduleAction');


let ModuleChecker = {

  contextTypes: {
    router: PropTypes.object
  },

  async componentWillMount() {
    moduleAction.setCurrentModule(this.props.module);
    this.initModule();
    AppStore.addChangeLangListener(this.initModule);
  },

  componentWillUnmount(){
    AppStore.removeChangeLangListener(this.initModule);
  },

  initModule(){
    this.props.initModuleAction();
  }

};

module.exports = ModuleChecker;
